import React from 'react'
import { IconCheckbox, IconTrash, IconX } from '@tabler/icons-react'
import Typography from '../atoms/Typography'
import { PrimaryButton } from '../atoms/buttons/PrimaryButton'

interface ProjectActionPanelProps {
  selectedCount: number
  onDelete: () => void
  onClear: () => void
}

const Divider = () => <div className="h-8 w-px shrink-0 bg-gray-500" />

export const ProjectActionPanel: React.FC<ProjectActionPanelProps> = ({ selectedCount, onDelete, onClear }) => (
  <div className="pointer-events-none fixed inset-x-0 bottom-[58px] z-[60] flex justify-center">
    {/* stopPropagation guards against the underlying grid/card pointer handlers stealing the click */}
    <div
      className="pointer-events-auto flex w-[min(806px,70vw)] items-center gap-4 rounded-xl border border-orange-500 bg-orange-500/10 px-5 py-3 shadow-lg"
      onPointerDown={(e) => e.stopPropagation()}
    >
      <div className="flex items-center gap-2">
        <div className="flex h-7 w-7 items-center justify-center rounded-full bg-orange-500">
          <IconCheckbox className="h-4 w-4 text-gray-900" />
        </div>
        <Typography variant="sm-bold" className="whitespace-nowrap text-gray-50">
          {selectedCount} {selectedCount === 1 ? 'project' : 'projects'} selected
        </Typography>
      </div>

      <Divider />

      <button
        onClick={onClear}
        className="flex items-center gap-2 text-sm font-medium text-gray-200 transition-colors hover:text-gray-50"
      >
        <IconX className="h-4 w-4" />
        Clear
      </button>

      <PrimaryButton
        size="sm"
        leftIcon={<IconTrash className="h-4 w-4" />}
        onClick={onDelete}
        className="ml-auto bg-red-600 hover:bg-red-500 active:bg-red-500"
      >
        Delete Selected
      </PrimaryButton>
    </div>
  </div>
)
